import { client, unwrap } from '../lib/http-client';
import type { ReportFormValues } from '../validation/report';

export async function submitIncidentReport(values: ReportFormValues): Promise<unknown> {
  const result = await client.POST('/api/v2/incident-reports/', {
    body: values,
  });
  return unwrap(result);
}
